const routesSettings = [
  {
    path: '/settings/profile',
    name: 'SettingsProfile',
    component: () => import('@/views/settings/ProfileView.vue'),
    meta: {
      title: 'Profile',
      backgroundTheme: 'brand-light'
    }
  },
  {
    path: '/settings/loadshedding',
    name: 'SettingsLoadshedding',
    component: () => import('@/views/settings/LoadsheddingView.vue'),
    meta: {
      title: 'Loadshedding zone',
      backgroundTheme: 'brand-light'
    }
  },
  {
    path: '/settings/connected-devices',
    name: 'SettingsConnectedDevices',
    component: () => import('@/views/settings/ConnectedDevicesView.vue'),
    meta: {
      title: 'Connected devices',
      backgroundTheme: 'brand-light'
    }
  },
  {
    path: '/settings/connected-devices/:propertyId/battery/:id',
    name: 'SettingsBattery',
    component: () => import('@/views/settings/BatteryView.vue'),
    meta: {
      title: 'SolarBot',
      backgroundTheme: 'brand-light'
    }
  },
  {
    path: '/settings/connected-devices/:propertyId/geyser/:id',
    name: 'SettingsGeyser',
    component: () => import('@/views/settings/GeyserView.vue'),
    meta: {
      title: 'Geyser',
      backgroundTheme: 'brand-light'
    }
  },
  {
    path: '/settings/subscriptions',
    name: 'SettingsSubscriptions',
    component: () => import('@/views/settings/SubscriptionsView.vue'),
    meta: {
      title: 'Subscriptions'
    }
  },
  {
    path: '/settings/wifi',
    name: 'SettingsWiFi',
    component: () => import('@/views/settings/WiFiView.vue'),
    meta: {
      title: 'Wi-Fi',
      backgroundTheme: 'brand-light'
    }
  },
  {
    path: '/settings/wifi/solarbot',
    name: 'SettingsWiFiSolarbot',
    component: () => import('@/views/settings/WiFiView.vue'),
    meta: {
      title: 'Wi-Fi',
      backgroundTheme: 'brand-light'
    }
  },
  {
    path: '/settings/wifi/hotbot',
    name: 'SettingsWiFiHotbot',
    component: () => import('@/views/settings/WiFiView.vue'),
    meta: {
      title: 'Wi-Fi',
      backgroundTheme: 'brand-light'
    }
  },
  {
    path: '/settings/change-password',
    name: 'SettingsChangePassword',
    component: () => import('@/views/settings/ChangePasswordView.vue'),
    meta: {
      title: 'Change password',
      backgroundTheme: 'brand-light'
    }
  },
  {
    path: '/settings/sign-out-everywhere',
    name: 'SettingsSignOutEverywhere',
    component: {}
  },
  {
    path: '/settings/sign-out',
    name: 'SettingsSignOut',
    component: {}
  }
]

export default routesSettings
